<template>
    <div class="col-sm-12 nopads">
        <div class="search-form">
            <div class="col-sm-12 search-form-title ms-2">
                <font-awesome-icon icon="search" />
                {{ $t('common.search') }}
            </div>
            <form class="no-margin p-2" @submit.prevent="onSubmit" @reset.prevent="onReset">
                <contract-filter ref="contractFilter" :user="user" :show-only-my-contracts-option="true"
                    @contractSet="setContract" @customerSet="setCustomer" @contractorSet="setContractor" />

                <div class="row nopads">
                    <div class="col-sm-6">
                        <span class="search-title">
                            {{ $t('ins_report.from_date') }}
                        </span>
                        <date-time-picker class="routa-input" v-model:date="startTime" format="dd.MM.yyyy HH:mm"
                            :enableTimePicker="true" :placeholder="$t('areas.set_work_time')" />
                    </div>
                    <div class="col-sm-6">
                        <span class="search-title">
                            {{ $t('ins_report.to_date') }}
                        </span>
                        <date-time-picker class="routa-input" v-model:date="endTime" format="dd.MM.yyyy HH:mm"
                            :enableTimePicker="true" :placeholder="$t('areas.set_work_time')" />
                    </div>
                </div>
                <div class="row" v-if="isDangerReport">
                    <div class="col-sm-6">
                        <span class="span-title">{{ $t('danger_report.event_type') }}</span>
                        <select
                            id="nopads"
                            v-model="type"
                            class="form-select form-select-sm col-sm-3"
                        >
                            <option :value="null">
                                {{ $t('danger_report.select_event_type') }}
                            </option>
                            <option
                                v-for="option in getDangerType()"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-6">
                        <span class="span-title">{{ $t('danger_report.handled') }}</span>
                        <select
                            id="nopads"
                            v-model="handled"
                            class="form-select form-select-sm col-sm-3"
                        >
                            <option :value="null">
                                {{ $t('common.all') }}
                            </option>
                            <option :value="true">
                                {{ $t('danger_report.handled') }}
                            </option>
                            <option :value="false">
                                {{ $t('danger_report.unhandled') }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-12 button-container">
                    <button type="reset" class="btn btn-danger form-button">{{ $t('ins_report.clear') }}</button>
                    <button type="submit" class="btn btn-primary form-button">{{ $t('ins_report.search') }}</button>
                </div>
            </form>
            <div v-if="loading" id="loader" class="spinner" />
        </div>
    </div>
</template>

<script>
import { restApi } from '../mixins/RestApiMixin'
import CompanyFilter from '../company/CompanyFilter'
import ContractFilter from '../contract/ContractFilter'
import { dangerHelper } from '../mixins/DangerMixin'
import DateTimePicker from "@/components/common/DateTimePicker";
import {timeUtils} from "../mixins/TimeUtils.js";

export default {
    name: 'search-filter',
    components: { ContractFilter, CompanyFilter, DateTimePicker },
    mixins: [restApi, dangerHelper, timeUtils],
    props: {
        isDangerReport: {
            type: Boolean,
            default: false
        },
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            startTime: '',
            endTime: '',
            customer: null,
            contract: null,
            contractor: null,
            handled: null,
            type: null
        }
    },

    mounted() {
        this.startTime = this.getMonthStart()
    },

    methods: {
        setContract: function (contract) {
            this.contract = contract
        },

        setCustomer: function (customer) {
            this.customer = customer
        },

        setContractor: function (contractor) {
            this.contractor = contractor
        },

        onReset: function () {
            this.startTime = null
            this.endTime = null
            this.handled = null
            this.type = null
            this.$refs.contractFilter.reset()
        },

        onSubmit: function () {
            let params = {
                endTime: this.endTime,
                startTime: this.startTime,
                customer: this.customer,
                contract: this.contract
            }
            if (this.isDangerReport) {
                params.type = this.type
                params.handled = this.handled
            }
            this.$emit('search', params)
        }
    }
}
</script>

<style scoped></style>
